import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import {
  existingInviteCodeAtom,
  type InviteCode,
} from '@root/entities/referral'
import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { AddInviteCodeDialog } from './add-invite-code-dialog'
import { EditInviteCodeDialog } from './edit-invite-code-dialog'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  initialInviteCode: InviteCode | undefined
}

export const InviteCodeDialog = ({
  open,
  onOpenChange,
  initialInviteCode,
}: Props) => {
  const { t } = useTranslation()

  const [existingInviteCode] = useAtom(existingInviteCodeAtom)
  return (
    <Root
      withClose
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('referral.invite_referral')}
    >
      {existingInviteCode ? (
        <EditInviteCodeDialog
          existingInviteCode={existingInviteCode}
          initialInviteCode={initialInviteCode}
          onDone={() => onOpenChange(false)}
          onCancel={() => onOpenChange(false)}
        />
      ) : (
        <AddInviteCodeDialog
          initialInviteCode={initialInviteCode}
          onDone={() => onOpenChange(false)}
          onCancel={() => onOpenChange(false)}
        />
      )}
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 400px;
`
